
export const StatusDocumento = {
    NAO_INTEGRADO: 'NAO_INTEGRADO',
    DESCONHECIDO: 'DESCONHECIDO',
    CRIACAO_PENDENTE: 'CRIACAO_PENDENTE',
    ASSINATURA_PENDENTE: 'ASSINATURA_PENDENTE',
    ASSINADO: 'ASSINADO',
    CRIADO_PENDENTE_ATUALIZAR_STATUS_ASSINATURA_PENDENTE: 'CRIADO_PENDENTE_ATUALIZAR_STATUS_ASSINATURA_PENDENTE'
}